// removed by extract-text-webpack-plugin
module.exports = {"Edit":"editableText__Edit__1maFC","EditContainer":"editableText__EditContainer__2r6Gj","EditLine":"editableText__EditLine__3MkrF","TextInput":"editableText__TextInput__o8ozI","TextArea":"editableText__TextArea__omfZ0","EditButtons":"editableText__EditButtons__3JrC_","ToggleEdit":"editableText__ToggleEdit__2qZ1X"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/EditableText/editableText.css
// module id = 915
// module chunks = 2